import { useRef, useEffect, useState } from "react";

// Canvas de assinatura: desenha com mouse ou dedo e devolve base64
export default function AssinaturaCanvas({ onConfirmar, onCancelar }) {
    const canvasRef = useRef(null);
    const desenhando = useRef(false);
    const temTraco = useRef(false);
    const [nome, setNome] = useState("");

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.strokeStyle = "#0d1b2a";
        ctx.lineWidth = 2.5;
        ctx.lineCap = "round";
        ctx.lineJoin = "round";
    }, []);

    function posicao(e) {
        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        const fonte = e.touches ? e.touches[0] : e;
        return {
            x: ((fonte.clientX - rect.left) / rect.width) * canvas.width,
            y: ((fonte.clientY - rect.top) / rect.height) * canvas.height,
        };
    }

    function iniciar(e) {
        e.preventDefault();
        desenhando.current = true;
        const ctx = canvasRef.current.getContext("2d");
        const { x, y } = posicao(e);
        ctx.beginPath();
        ctx.moveTo(x, y);
    }

    function desenhar(e) {
        if (!desenhando.current) return;
        e.preventDefault();
        temTraco.current = true;
        const ctx = canvasRef.current.getContext("2d");
        const { x, y } = posicao(e);
        ctx.lineTo(x, y);
        ctx.stroke();
    }

    function parar() {
        desenhando.current = false;
    }

    function limpar() {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        temTraco.current = false;
    }

    function confirmar() {
        if (!temTraco.current || !nome.trim()) return;
        onConfirmar({
            assinaturaBase64: canvasRef.current.toDataURL("image/png"),
            nomeSignatario: nome.trim(),
        });
    }

    return (
        <div>
            <label className="form-label he-dourado">Nome completo de quem assina *</label>
            <input className="form-control" style={{marginBottom: 12}} value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Nome do responsável"/>

            <div style={{border: "2px dashed #d4af37", borderRadius: 10, overflow: "hidden", background: "#fff"}}>
                <canvas
                    ref={canvasRef}
                    width={560}
                    height={200}
                    style={{width: "100%", display: "block", touchAction: "none", cursor: "crosshair"}}
                    onMouseDown={iniciar}
                    onMouseMove={desenhar}
                    onMouseUp={parar}
                    onMouseLeave={parar}
                    onTouchStart={iniciar}
                    onTouchMove={desenhar}
                    onTouchEnd={parar}
                />
            </div>
            <div style={{fontSize: "0.75em", color: "#9aa5b5", marginTop: 4}}>Assine no quadro acima (mouse ou dedo)</div>

            <div style={{display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 12}}>
                <button type="button" className="btn btn-outline-he" onClick={limpar}><i className="bi bi-eraser"></i> Limpar</button>
                {onCancelar && <button type="button" className="btn btn-outline-he" onClick={onCancelar}>Cancelar</button>}
                <button type="button" className="btn btn-he" onClick={confirmar}><i className="bi bi-pen"></i> Confirmar assinatura</button>
            </div>
        </div>
    );
}
